import React, { useState, useEffect } from 'react';
import Cookies from "cookies-js"

import Box from '../Box'

export default props => {
    const [voted, setVoted] = useState(null)
    const [hasCookie, setHasCookie] = useState(false)

    useEffect(() => {
        const value = Cookies.get("_brid");
        if (typeof value === "string") {
            const [blockID, articleID] = value.split(".");
            setHasCookie(true)
            if (blockID === props.settings.uID) {
                setVoted(articleID)
            }
        }
    }, [])

    return (
        <section className="container">
            <div className="row" style={{ position: 'relative' }}>
                <Box {...props}
                    id="b1"
                    type="ABridCompare"
                    settings={props.settings.b1}
                    preserveImageRatio={true}
                    classes=""
                    secondArticleID={props.settings.b2?.articleID}
                    thirdArticleID={props.settings.b3?.articleID}
                    voted={voted}
                    setVoted={setVoted}
                    uID={props.settings.uID}
                    hasCookie={hasCookie}
                />
            </div>
            <div className="row" style={{ position: 'relative' }}>
                <Box {...props}
                    id="b2"
                    type="ABridCompare"
                    settings={props.settings.b2}
                    preserveImageRatio={true}
                    classes=""
                    secondArticleID={props.settings.b1?.articleID}
                    thirdArticleID={props.settings.b3?.articleID}
                    voted={voted}
                    setVoted={setVoted}
                    uID={props.settings.uID}
                    hasCookie={hasCookie}
                />
            </div>
            <div className="row" style={{ position: 'relative' }}>
                <Box {...props}
                    id="b3"
                    type="ABridCompare"
                    settings={props.settings.b3}
                    preserveImageRatio={true}
                    classes=""
                    secondArticleID={props.settings.b1?.articleID}
                    thirdArticleID={props.settings.b2?.articleID}
                    voted={voted}
                    setVoted={setVoted}
                    uID={props.settings.uID}
                    hasCookie={hasCookie}
                />
            </div>
        </section>
    );
}